export default "__VITE_ASSET__Bb6ix0$6__"